<template>
  <div>
    <Toast />
    <div class="tableContainer mx-auto">
      <div class="d-flex my-3">
        <h6>All Company Sub routes</h6>
        <div class="add-btn ml-auto">
          <button
            class="btn show-modal"
            data-toggle="modal"
            data-target="#myModal"
            @click.prevent="getPricelessBps()"
          >
            Add Sub route
          </button>
        </div>
      </div>
      <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form col-lg-12 mx-auto bg-white">
                <h6 class="text-center mt-2 mb-3 heading">
                  Register new breakpoints
                </h6>
                <form method="post" class="add-route-form col-lg-11 mx-auto">
                  <div class="form-group col-sm-6 col-12 col-lg-3 ml-0">
                    <select
                      class="form-control"
                      v-model="regiroutes"
                      name="regiroutes"
                      id="regiroutes"
                      required
                    >
                      <option disabled value>select route</option>
                      <option
                        v-for="route in routes"
                        :key="route"
                        :value="route.id"
                      >
                        {{ route.source }}--{{ route.destination }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-sm-6 col-12 col-lg-3">
                    <input
                      type="text"
                      class="form-control"
                      name="bp1"
                      v-model="bp1"
                      placeholder="Breakpoint"
                      required
                    />
                  </div>
                  <div class="form-group col-sm-6 col-12 col-lg-3">
                    <input
                      type="number"
                      class="form-control"
                      name="distance"
                      v-model="distance"
                      placeholder="Distance(Km) from main route"
                      required
                    />
                  </div>
                  <div class="text-center d-flex saveroute">
                    <button
                      type="submit"
                      name="newbp"
                      @click.prevent="newBp()"
                      class="btn btn-primary reg"
                    >
                      Add<!-- <span v-if="hasSubmitted" class="spinner-border spinner-border-sm ml-2 my-auto"></span> -->
                    </button>
                    <button
                      type="submit"
                      name="newbpfinal"
                      @click.prevent="newBpFinal()"
                      class="btn btn-success finish"
                    >
                      Finish<!-- <span v-if="hasSubmitted" class="spinner-border spinner-border-sm ml-2 my-auto"></span> -->
                    </button>
                  </div>
                </form>
                <p class="text-secondary text-center mt-2 finish2">
                  ⚠️click finish to register the last breakpoint and immediately
                  start registering their prices below⚠️
                </p>

                <div class="added-buses col-lg-12 col-12 mx-auto">
                  <div v-if="!showTablebp" class="table_placeholder">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="120"
                        height="120"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                          d="M4 15V8.5a4.5 4.5 0 0 1 9 0v7a2.5 2.5 0 1 0 5 0V8.83a3.001 3.001 0 1 1 2 0v6.67a4.5 4.5 0 1 1-9 0v-7a2.5 2.5 0 0 0-5 0V15h3l-4 5-4-5h3zm15-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                          fill="rgba(149,164,166,1)"
                        />
                      </svg>
                      <p id="add-buses-text">
                        Added breakpoints will appear here in order to register
                        their prices
                      </p>
                    </div>
                  </div>
                  <div v-if="showTablebp" class="col-lg-11 cont">
                    <h5 class="text-primary myModal-heading mb-4">
                      Register Prices
                    </h5>
                    <div
                      class="priceregistration d-flex justify-content-center"
                      v-for="(breakpoint, i) in breakpoints"
                      :key="i"
                    >
                      <div
                        class="d-flex justify-content-between text-body mr-3 pt-2 routedata"
                        style="width: 40%"
                      >
                        <div
                          class="d-flex justify-content-start"
                          style="width: 30%"
                        >
                          <p>{{ breakpoint.source }}</p>
                        </div>
                        <div
                          class="d-flex justify-content-start text-secondary"
                        >
                          <p>To</p>
                        </div>
                        <div
                          class="d-flex justify-content-start"
                          style="width: 40%"
                        >
                          <p>{{ breakpoint.destination }}</p>
                        </div>
                      </div>
                      <form class="d-flex">
                        <div class="form-group price_input">
                          <input
                            type="number"
                            class="form-control"
                            name="price"
                            v-model="breakpoints[i].price"
                            placeholder="Price"
                            required
                          />
                        </div>
                        <button
                          type="submit"
                          name="priceReg"
                          @click.prevent="priceReg(i)"
                          class="btn ml-2 btn-primary"
                        >
                          Add
                        </button>
                      </form>
                    </div>
                  </div>
                </div>

                <div class="decision-btns ml-auto mb-4">
                  <button
                    class="btn px-5"
                    @click="clearTable"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card table-view">
        <DataTable
          :value="breakPoints"
          :paginator="true"
          class="p-datatable-customers"
          :rows="10"
          v-model:selection="selectedProducts3"
          dataKey="id"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:filters="filters2"
          filterDisplay="row"
          :loading="LoadingData"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          :globalFilterFields="['routeid', 'source', 'destination', 'price']"
        >
          <template #header>
            <div class="p-d-flex p-jc-end">
              <span class="p-input-icon-left ">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters2['global'].value"
                  placeholder="Keyword Search"
                />
              </span>
            </div>
          </template>
          <template #empty>
            No break points found.
          </template>
          <template #loading>
            Loading break points data. Please wait.
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column
            field="routeid"
            header="Route name"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.routeid }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['routeid'].value"
                class="p-column-filter"
                :placeholder="`Search by route name - `"
              />
            </template>
          </Column>

          <Column
            field="source"
            header="Break point source"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.source }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['source'].value"
                class="p-column-filter"
                :placeholder="`Search by source - `"
              />
            </template>
          </Column>

          <Column
            field="destination"
            header="Break point destination"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.destination }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['destination'].value"
                class="p-column-filter"
                :placeholder="`Search by destination - `"
              />
            </template>
          </Column>
          <Column
            field="price"
            header="Price"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.price }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['price'].value"
                class="p-column-filter"
                :placeholder="`Search by price - `"
              />
            </template>
          </Column>
        </DataTable>
      </div>

      <!-- table card for mobile -->

      <div class="card mobile_cards_instead_of_table ">
        <DataView
          :value="breakPoints"
          :paginator="true"
          :rows="9"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <template #empty>
            No breakpoints found.
          </template>
          <template #list="slotProps">
            <div class="p-col-12">
              <div class="col-sm-12 col-12 single-card">
                <div class="sub-content d-flex">
                  <p class="title">Main route:</p>
                  <p class="content pl-2">{{ slotProps.data.routeid }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Breakpoint source:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.source }}
                  </p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Breakpoint destination:</p>
                  <p class="content pl-2">{{ slotProps.data.destination }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Breakpoint price:</p>
                  <p class="content pl-2">{{ slotProps.data.price }}</p>
                </div>
              </div>
            </div>
          </template>
        </DataView>
      </div>

      <div class="d-flex loader" v-if="LoadingData">
        <span
          v-if="true"
          class="spinner-border spinner-border-sm ml-2 my-auto"
        ></span>
        <p>Please wait. We are loading data...</p>
      </div>
    </div>
  </div>
</template>
<script>
import AdminSidebar from "@/components/adminSidebar.vue";
//Bootstrap and jQuery libraries
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import { FilterMatchMode } from "primevue/api";
import $ from "jquery";
import axios from "axios";
import jwt_decode from "jwt-decode";
const BreakPointsUrl = `https://bookinga.herokuapp.com/api/v1/company/routes/breakpoints`;
const RoutesUrl = `https://bookinga.herokuapp.com/api/v1/company/routes/`;
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {
    AdminSidebar,
  },
  data: function() {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        routeid: { value: null, matchMode: FilterMatchMode.CONTAINS },
        source: { value: null, matchMode: FilterMatchMode.CONTAINS },
        destination: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
        price: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      LoadingData: true,
      Routes: [],
      errors: false,
      success: false,
      modalClose: "",
      breakPoints: [],
      routes: [
        {
          id: "",
          source: "",
          destination: "",
        },
      ],
      showTablebp: false,
      regiroutes: "",
      bp1: "",
      distance: "",
      hasSubmitted: false,
      possibleDestinations: [],
      breakpoints: [],
      price: "",
      data: {
        mainRouteId: "",
        Route: "",
        Source: "",
        Destination: "",
        Price: "",
      },
    };
  },
  mounted() {
    //API Call
    axios.get(BreakPointsUrl, config).then((res) => {
      if (
        res.data.message != "no breakpoint of that company are registered yet"
      ) {
        this.breakPoints = res.data.message;
        axios.get(RoutesUrl, config).then((res) => {
          this.Routes = res.data.data;
          for (let i = 0; i < this.breakPoints.length; i++) {
            for (let j = 0; j < res.data.data.length; j++) {
              if (this.breakPoints[i].routeid == res.data.data[j].id) {
                this.breakPoints[i].routeid =
                  res.data.data[j].source +
                  " <-> " +
                  res.data.data[j].destination;
              }
            }
          }
        });
        this.LoadingData = false;
      } else {
        this.LoadingData = false;
      }
    });
    axios
      .get(RoutesUrl, config)
      .then((res) => {
        if (res.data.message != "No routes for your company") {
          this.routes = res.data.data;
        }
      })
      .catch((err) => console.log(err));
  },
  methods: {
    register() {
      if (
        this.data.Source == "" ||
        this.data.Destination == "" ||
        this.data.Price == ""
      ) {
        this.errors = true;
        document.getElementById("error").innerHTML =
          "All the subroute fields are required";
      } else if (this.data.Source.length < 2 || this.data.Source.length > 40) {
        this.errors = true;
        document.getElementById("error").innerHTML =
          "Please enter a valid sub route source";
      } else if (
        this.data.Destination.length < 2 ||
        this.data.Destination.length > 40
      ) {
        this.errors = true;
        document.getElementById("error").innerHTML =
          "Please enter a valid sub route Destination";
      } else {
        this.errors = false;
        axios
          .post(
            `https://bookinga.herokuapp.com/api/v1/company/routes/${this.data.mainRouteId}/breakpoint
`,
            {
              source: this.data.Source,
              destination: this.data.Destination,
              price: this.data.Price,
            },
            config
          )
          .then((response) => {
            if (response.data.status == 201) {
              this.success = true;
              this.errors = false;
              document.getElementById("success").innerHTML =
                "Sub route registered successfully";
              (this.data.Source = ""),
                (this.data.Destination = ""),
                (this.data.Price = "");
              return;
            } else {
              this.success = false;
              this.errors = true;
              return (document.getElementById("error").innerHTML =
                response.data.message);
            }
          })
          .catch((error) => {
            this.errors = true;
            this.success = false;
            document.getElementById("error").innerHTML = error;
          });
      }
    },
    getPricelessBps(){
              axios
                .get(
                  `https://bookinga.herokuapp.com/api/v1/company/routes/pricelessBreakpoints`,
                  config
                )
                .then((res) => {
                  //first empty the breakpoints array before adding the new elements
                  this.breakpoints = [];
                  this.breakpoints = res.data.message;
                  //check if price in not null
                  for (let i = 0; i < this.breakpoints.length; i++) {
                    if (this.breakpoints[i].price == null) {
                      //filter the breakpoint
                      this.breakpoints = this.breakpoints.filter((item) => {
                        return item.price == null;
                      });
                      this.showTablebp = true;
                    }
                  }
                })
                .catch((err) => console.log(err));      
    },
    newBp() {
      if (this.regiroutes != "" && this.bp1 != "" && this.distance != "") {
        this.possibleDestinations.unshift({
          routeid: this.regiroutes,
          destination: this.bp1,
          distance: this.distance,
        });
        this.bp1 = "";
        this.distance = "";

        return this.$toast.add({
          severity: "success",
          summary: "breakpoints added",
          detail: "Breakpoint added to list successfully ",
          life: 5000,
        });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A breakpoint combination should have all the 3 fields.",
          life: 5000,
        });
      }
    },
    newBpFinal() {
      if (this.regiroutes != "" && this.bp1 != "" && this.distance != "") {
        this.possibleDestinations.unshift({
          routeid: this.regiroutes,
          destination: this.bp1,
          distance: this.distance,
        });
        //first filter all elements that have the same route id
        let filtered = this.possibleDestinations.filter(
          (element) => element.routeid == this.regiroutes
        );
        //then delete all other elements from the possibleDestinations array
        this.possibleDestinations = filtered;

        axios
          .post(
            `https://bookinga.herokuapp.com/api/v1/company/routes/${this.regiroutes}/breakpoint`,
            { possibleDestinations: this.possibleDestinations },
            config
          )
          .then((res) => {
            if (res.data.success == true) {
              axios
                .get(
                  `https://bookinga.herokuapp.com/api/v1/company/routes/${this.regiroutes}/breakpoint`,
                  config
                )
                .then((res) => {
                  //first empty the breakpoints array before adding the new elements
                  this.breakpoints = [];
                  this.breakpoints = res.data.message;
                  //check if price in not null
                  for (let i = 0; i < this.breakpoints.length; i++) {
                    if (this.breakpoints[i].price == null) {
                      //filter the breakpoint
                      this.breakpoints = this.breakpoints.filter((item) => {
                        return item.price == null;
                      });
                    }
                  }
                })
                .catch((err) => console.log(err));

              this.regiroutes = "";
              this.bp1 = "";
              this.distance = "";

              this.showTablebp = true;

              return this.$toast.add({
                severity: "success",
                summary: "breakpoints registration",
                detail: "Breakpoints registered successfully",
                life: 5000,
              });
            } else {
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: res.data.message,
                life: 5000,
              });
            }
          })
          .catch((err) => {
            // console.log(err)
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail: "failed to register breakpoints",
              life: 5000,
            });
          });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A breakpoint combination should have all the 3 fields.",
          life: 5000,
        });
      }
    },
    priceReg(index) {
      // console.log(this.breakpoints[index])
      let price = parseInt(this.breakpoints[index].price, 10);
      if (this.breakpoints[index].price != "") {
        axios
          .put(
            `https://bookinga.herokuapp.com/api/v1/company/routes/${this.breakpoints[index].routeid}/breakpoint/${this.breakpoints[index].id}/addPrice`,
            { price: price },
            config
          )
          .then((res) => {
            if (res.data.success == true) {
              //remove from list
              this.breakpoints.splice(index, 1);
              this.price = "";

              return this.$toast.add({
                severity: "success",
                summary: "price addition",
                detail: "Price added successfully",
                life: 5000,
              });
            } else {
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: res.data.message,
                life: 5000,
              });
            }
          })
          .catch((err) => {
            // console.log(err)
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail: "failed to add price",
              life: 5000,
            });
          });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A price is needed",
          life: 5000,
        });
      }
    },
  },
  created() {
    // const token = localStorage.getItem("jwt");
    // const decoded = jwt_decode(token);
    // const userRole = decoded.role;
    // if ( userRole != "admin") {
    //   return router.push("/dashboard");
    // }
    
    $(document).ready(function() {
      $(".show-modal").click(function() {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
};
</script>
<style lang="scss" scoped>
@import "../sharedStyles.scss";
.add-route-form {
  display: flex;
  justify-content: space-around;
  margin: 0 !important;
  margin: auto !important;
  width: 99%;
}
.form-control {
  margin: 0 !important;
}
.form {
  margin: 0 !important;
  padding: 0 !important;
}
.form-group {
  margin-bottom: 0 !important;
  padding: 0;
  margin-top: 2%;
}
.saveroute {
  margin-bottom: 0 !important;
  padding: 0;
  margin-top: 2%;
  justify-content: space-between;
  min-width: 20%;

  .reg {
    font-size: 0.75em !important;
    min-width: 40% !important;
  }
  .finish {
    font-size: 0.75em !important;
    width: 50% !important;
  }
}
.finish2 {
  font-size: 0.85em !important;
}
.price_input {
  width: 65%;
}
.priceregistration {

  form {
    width: 45%;
    margin-bottom: 1%;

    button {
      margin-top: 2%;
    }
  }
}

  .cont{
    width: inherit;
    height: inherit;
  }
  .added-buses {
    height: 23rem;
  }

@media only screen and (max-width: 600px) {
  .add-route-form {
    display: flex;
    flex-direction: column;
  }
  .routedata {
    width: 85% !important;
  }
  .cont {
    padding: 0;
    padding-left: 2% !important;
    width: 100% !important;
  }
  .added-buses {
    width: 95%;
    padding: 2% !important;
  }
  .priceregistration {
    display: flex;
    flex-direction: column;

    form {
      width: 100% !important;

      div {
        padding: 0;
        margin-right: 2%;
        width: 100% !important;

        input {
          width: 100% !important;
        }
      }
      button {
        min-width: 45px !important;
      }
    }
  }
}
</style>
